import { Injectable, Inject } from '@angular/core';
import { UrlBuilderHelper } from '@newroom-connect/library/helpers';

@Injectable({
  providedIn: 'root'
})
export class CustomDomainService {
  constructor(@Inject('environment') private environment: unknown) {}

  /**
   * Redirects the browser to the specified custom domain.
   * @param customDomain The domain name to redirect to.
   */
  public redirectToCustomDomain(customDomain: string | null): void {
    if (!this.shouldRedirectToCustomDomain(customDomain)) {
      return;
    }

    const customUrl = `https://${customDomain}${window.location.pathname}${window.location.search}${window.location.hash}`;

    window.location.href = customUrl;
  }

  /**
   * Determines if the current project should redirect to its custom domain.
   * @param customDomain The domain name to redirect to.
   * @returns True if redirect is needed, false otherwise.
   */
  private shouldRedirectToCustomDomain(customDomain: string | null): boolean {
    if (!customDomain) {
      return false;
    }

    // Skip redirect in local development
    if (UrlBuilderHelper.isLocalDevelopment()) {
      return false;
    }

    // Skip if already on custom domain
    const currentHostname = window.location.hostname;

    return currentHostname !== customDomain;
  }
}
